@layer design-system {
  .separator {
    height: 1px;
    background-color: var(--border-soft);
  }

  .dropdownContent {
    display: flex;
    flex-direction: column;
    min-width: 290px;
    max-width: 400px;
    background-color: var(--surface-default);
    border: 1px solid var(--border-soft);
    border-radius: 4px;
    box-shadow: 0 6px 10px 4px rgba(0, 0, 0, 15%),
      0 2px 3px 0 rgba(0, 0, 0, 30%);
    z-index: var(--z-index-dropdown);
    gap: 8px;
    padding: 8px 0;

    > div:last-child {
      [data-separator] {
        display: none;
      }
    }
  }
}
